/* tslint:disable max-line-length */ /* for clarity's sake */
import { L10nMessages } from 'core/l10n/components';

const PHONE_BASE =
    '(?:(?:\\+?1s*(?:[\\.\\-]s*)?)?(?:\\(s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))s*(?:[\\.\\-]s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})s*(?:[\\.\\-]s*)?([0-9]{4})(?:s*(?:#|x\\.?|ext\\.?|extension)s*(\\d+))?';
const PHONE_BASE_SIMPLE = '^1?(\\d{10})';

export const SHORTCODE_OR_PHONE = `^(${PHONE_BASE}|[0-9]{5,6})$`;
export const HEX_COLOR = '^[a-fA-F0-9]{6}$';
export const AT_LEAST_ONE_DIGIT = '(?=.*\\d)';
export const AT_LEAST_ONE_UPPER_CASE = '(?=.*?[A-Z])';
export const AT_LEAST_ONE_LOWER_CASE = '(?=.*?[a-z])';
export const PASSWORD_WITH_ONEUPPERCASE_ONENUMBER = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^ws]).{8,50}$';
export const AT_LEAST_EIGHT_CHARACTERS = '.{8,}';
export const BETWEEN_EIGHT_TO_FIFTY_CHARACTERS = '^.{8,50}$';
export const ZIPCODE = '^\\d{5}(?:[\\-\\s]\\d{4})?$';
export const CAN_POSTAL_CODE = '^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$';
export const FIRST_NAME = "^[a-zA-Z]{1}([a-zA-Z0-9\\.'\\s&\\/\\-])*$";
export const FIRST_NAME_OR_LAST_NAME = "^[a-zA-Z]('*(?=\\w)){2}([a-zA-Z0-9'\\s&\\/\\-])*$";
export const EMAIL_ADDRESS =
    '^(?:[A-Za-z0-9!$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[A-z0-9!$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9\\-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9\\-]*[A-Za-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-Za-z0-9\\-]*[A-Za-z0-9]:(?:[\\x01\\-\\x08\\x0b\\x0c\\x0e\\-\\x1f\\x21\\-\\x5a\\x53\\-\\x7f]|\\\\[\\x01\\-\\x09\\x0b\\x0c\\x0e\\-\\x7f])+)\\])$';
export const EMAIL_ADDRESS_LOGIN =
    '^(?:[A-Za-z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[A-z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9\\-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9\\-]*[A-Za-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-Za-z0-9\\-]*[A-Za-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e\\-\\x1f\\x21\\-\\x5a\\x53-\\x7f]|\\\\[\\x01\\-\\x09\\x0b\\x0c\\x0e\\-\\x7f])+)\\])$';
export const EMAIL_LOCAL_PART =
    '^(?:[A-Za-z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[A-z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")$';
export const PHONE = `${PHONE_BASE_SIMPLE}`;
export const FORMATTED_PHONE = `${PHONE_BASE}`;
export const DOMAIN = '^([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\\.)+[a-zA-Z]{2,}$';
export const HTTP_URL =
    "^http(s)?:\\/\\/[\\w\\.\\-]+(?:\\.[\\w\\.\\-]+)+[\\w\\-\\._~:\\/?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%\\.]+$";
export const HTTPS_URL = "^https://[\\w\\.\\-]+(?:\\.[\\w\\.\\-]+)+[\\w\\._~:\\/?#\\[\\]@!$&'\\(\\)\\*+,;=%\\.]+$";
export const URL = "^(http(s)?:\\/\\/|\\/)[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=%.]+$";

export const DISALLOW_PO_BOX =
    '^((?!((?:[Pp][Oo][Ss][Tt](?:[Aa][Ll])? (?:[Oo][Ff][Ff][Ii][Cc][Ee] )?|[Pp][. ]?[Oo][. ]*)[Bb](?:[Oo][Xx])?[ .]*[0-9#])).)*$';
const SAME_NUMBER = '(?:(\\d)\\1{2})-(?:(\\d)\\1{1})-(?:(\\d)\\1{3})';
const RESERVED_SSN_NUMBERS = '219-09-9999|078-05-1120|012-34-5678|876-54-3210|123-45-6789|987-65-4321';
export const SOCIAL_SECURITY_NUMBER_USA = `^(?!${RESERVED_SSN_NUMBERS})(?!${SAME_NUMBER})(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$`;
export const SOCIAL_SECURITY_NUMBER_CAN = '^([0-9]{3}[-]*[0-9]{3}[-]*[0-9]{3})*$';
export const PHONE_MASKED_PATTERN = '^1?[\\(]\\d{3}[\\)] \\d{3}[\\-]\\d{4}';
// eslint-disable-next-line prettier/prettier
export const US_PHONE_MASK = ['1', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

interface ValidationRule {
    pattern: string;
    message: keyof L10nMessages;
}

export const passwordValidationRules: ValidationRule[] = [
    {
        pattern: AT_LEAST_ONE_DIGIT,
        message: 'password_validation_atLeastOneDigit',
    },
    {
        pattern: AT_LEAST_ONE_UPPER_CASE,
        message: 'password_validation_atLeastOneUppercase',
    },
    {
        pattern: AT_LEAST_EIGHT_CHARACTERS,
        message: 'password_validation_atLeastEightCharacters',
    },
];

export const newPasswordValidationRules: ValidationRule[] = [
    {
        pattern: AT_LEAST_ONE_UPPER_CASE,
        message: 'password_validation_oneUppercaseLetter',
    },
    {
        pattern: AT_LEAST_ONE_LOWER_CASE,
        message: 'password_validation_oneLowercaseLetter',
    },
    {
        pattern: AT_LEAST_ONE_DIGIT,
        message: 'password_validation_oneNumber',
    },
    {
        pattern: BETWEEN_EIGHT_TO_FIFTY_CHARACTERS,
        message: 'password_validation_betweenEightAndFiftyCharactersInclusive',
    },
];
